import {
    CONFIRMED_GET_ROLES
} from '../actions/role/RoleTypes';
const initialState = {
    roles: [],
    loading: false,
};

function RolesReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'SET_ROLES_LOADING':
            return {
                ...state,
                loading: actions.payload,
            };
        case CONFIRMED_GET_ROLES:
            return {
                ...state,
                roles: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {RolesReducer};